var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeFilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 106,
    viewBox: "0 0 86 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0821235C0 0.0821235 12.3651 0.293684 20.5227 0.0821235C29.4313 -0.14891 34.0906 0.192561 43 0.0821235C51.5337 -0.0236566 55.9661 0.0821235 64.5 0.0821235C73.0339 0.0821235 86 0.0821235 86 0.0821235V106H0V0.0821235Z",
    fill: "url(#paint0_linear)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 13.9869,
    cy: 94.5166,
    rx: 2.21739,
    ry: 2.29687,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 43.4098,
    cy: 99.1104,
    rx: 2.21739,
    ry: 2.29688,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 74.7945,
    cy: 92.2195,
    rx: 2.21739,
    ry: 2.29687,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 59.1022,
    cy: 71.5478,
    rx: 2.21739,
    ry: 2.29688,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 29.6788,
    cy: 85.3288,
    rx: 2.21739,
    ry: 2.29687,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.2,
    cx: 29.6788,
    cy: 54.2969,
    rx: 2.21739,
    ry: 2.29687,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 43,
    y1: -4.66617,
    x2: 43,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeFilling);
export default __webpack_public_path__ + "static/media/orangeFilling.67bc46aa09523ef9c26838a2dfce3ed0.svg";
export { ForwardRef as ReactComponent };